import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, of, EMPTY} from 'rxjs';
import {PpBreadcrumbsResolver, Breadcrumb} from 'pp-breadcrumbs';
import {catchError, mergeMap} from 'rxjs/operators';
import {AdminEsgService} from '@app/services/admin/admin-esg.service';

@Injectable()
export class AdminEsgResolver extends PpBreadcrumbsResolver {
  constructor(private adminEsgService: AdminEsgService) {
    super();
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Breadcrumb[]> | Promise<Breadcrumb[]> | Breadcrumb[] {
    const id = Number(route.params['id']);
    if (id === 0) {
      return of([{
        text: 'Add new ESG providers',
        path: this.getFullPath(route)
      }]);
    } else {
      return this.adminEsgService.get(id, true).pipe(catchError(error => {
          return EMPTY;
        }), mergeMap(data => {
          if (data) {
            return of([{
              text: data.esgName,
              path: this.getFullPath(route)
            }]);
          } else {
            return EMPTY;
          }
        })
      );
    }
  }
}
